import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import lodash from 'lodash'
import Chart from './components/Chart'
import useGlobalConfigStore from '@/stores/globalConfig'
import useStationStore from '@/stores/oneStation'
import { useParams } from 'react-router-dom'
import MqttServer from '@/utils/mqttUtil'
import { getDeviceData } from '@/utils/getData'
import { FunGroup, StationVirtualPoint } from '@/type/stationType'
import ItemValue from './components/ItemValue'
import { useTranslation } from 'react-i18next'

const Grid: React.FC = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const mqtt_serve = useStationStore(state => state.mqtt_serve)
  const device = useStationStore(state => state.device)
  const station_virtual_label = useStationStore(state => state.station_virtual_label)
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  let targetGroup: FunGroup | undefined,
    mqtt: MqttServer | undefined,
    uuid: string = '',
    id: number = 0
  const [dataTop, setDataTop] = useState<{ label: string; value: string | number; unit: string }[]>([
    { label: 'Day Grid Buy Power', value: 0, unit: 'Wh' },
    { label: 'Total Grid Buy Power', value: 0, unit: 'Wh' },
    { label: 'Day Grid Sell Power', value: 0, unit: 'Wh' },
    { label: 'Total Grid Sell Power', value: 0, unit: 'Wh' },
  ])
  const [dataBottom, setDataBottom] = useState<{ label: string; value: string | number; unit: string }[]>([])
  const [gridBuySell, setGridBuySell] = useState(0)
  const [chartPoints, setChartPoints] = useState<StationVirtualPoint[]>([])
  const [chartDeviceId, setChartDeviceId] = useState<number>(0)

  const getData = async () => {
    if (targetGroup) {
      let res: any
      try {
        res = await getDeviceData(
          [{ device_id: Number(id), defines: targetGroup.funs.map(item => item.fun_code) }],
          mqtt as MqttServer,
          uuid
        )
        if (res.code === 1) {
          res.data[0].datas.forEach((item: { id: number; property_code: string; value: string }) => {
            let targetFun = targetGroup?.funs.find(fun => fun.fun_code === item.property_code)
            if (targetFun) {
              targetFun.value = Number(item.value)
            }
          })
          // console.log(targetGroup)
        }
      } catch (e) {
        console.log(e)
      }
      const funs = targetGroup.funs
      const dataTopTemp = [
        {
          label: 'Day Grid Buy Power',
          value: funs.find(fun => fun.fun_name === 'Day_gridbuy_power_Wh')?.value || 0,
          unit: funs.find(fun => fun.fun_name === 'Day_gridbuy_power_Wh')?.unit || '',
        },
        {
          label: 'Total Grid Buy Power',
          value: funs.find(fun => fun.fun_name === 'Total_gridBuy_powerWh')?.value || 0,
          unit: funs.find(fun => fun.fun_name === 'Total_gridBuy_powerWh')?.unit || '',
        },
        {
          label: 'Day Grid Sell Power',
          value: funs.find(fun => fun.fun_name === 'Day_gridsell_powerWh')?.value || 0,
          unit: funs.find(fun => fun.fun_name === 'Day_gridsell_powerWh')?.unit || '',
        },
        {
          label: 'Total Grid Sell Power',
          value: funs.find(fun => fun.fun_name === 'Total_gridsell_powerWh')?.value || 0,
          unit: funs.find(fun => fun.fun_name === 'Total_gridsell_powerWh')?.unit || '',
        },
      ]
      const dataBottomTemp = funs
        .filter(
          fun =>
            fun.fun_name !== 'Grid->0 buy <0 sell' &&
            fun.fun_name !== 'Day_gridbuy_power_Wh' &&
            fun.fun_name !== 'Total_gridBuy_powerWh' &&
            fun.fun_name !== 'Day_gridsell_powerWh' &&
            fun.fun_name !== 'Total_gridsell_powerWh'
        )
        .map(fun => ({ label: fun.fun_name, value: fun.value, unit: fun.unit }))

      setDataTop(dataTopTemp)
      setDataBottom(dataBottomTemp)
      setGridBuySell((funs.find(fun => fun.fun_name === 'Grid->0 buy <0 sell')?.value as number) || 0)

      const targetLabel = station_virtual_label.find(item => item.type === 'sd')
      if (targetLabel) {
        setChartPoints(
          targetLabel.points.filter(
            item => item.property_code === 'I' || item.property_code === 'KRA' || item.property_code === 'P'
          )
        )
      }
      setChartDeviceId(id)
    }
  }

  useEffect(() => {
    if (initFinished) {
      const targetDevice = lodash.cloneDeep(device.find(item => item.id === Number(deviceId)))
      if (targetDevice) {
        targetGroup = targetDevice.fun_group?.find(item => item.group_name === 'Grid')
        mqtt = mqtt_serve[targetDevice.mqtt_server_id]
        uuid = targetDevice.iot_gateway_uuid
        id = targetDevice.device_id
      }
      getData()
    }
  }, [initFinished])

  return (
    <div id='Grid'>
      <div className='Grid__item1'>
        {'Grid->0 buy <0 sell: '}
        {gridBuySell}
      </div>
      <div className='Grid__item2'>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <div className='Grid__item2__buy Grid__item2__box'>
              <div className='Grid__item2__buy__title'>
                <img src='/assets/image/buy.svg' />
                {t('device.buy')}
              </div>
              <Row style={{ marginLeft: '28px', marginTop: '20px' }}>
                <Col span={12}>
                  <ItemValue {...dataTop[0]} />
                </Col>
                <Col span={12}>
                  <ItemValue {...dataTop[1]} />
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={12}>
            <div className='Grid__item2__buy Grid__item2__box'>
              <div className='Grid__item2__buy__title'>
                <img src='/assets/image/sell.svg' />
                {t('device.sell')}
              </div>
              <Row style={{ marginLeft: '28px', marginTop: '20px' }}>
                <Col span={12}>
                  <ItemValue {...dataTop[2]} />
                </Col>
                <Col span={12}>
                  <ItemValue {...dataTop[3]} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <div className='Grid__other'>
        <div className='Grid__item2__buy__title'>
          <img src='/assets/image/setting.svg' />
          {t('device.other')}
        </div>
        <Row style={{ marginLeft: '28px' }}>
          {dataBottom.map(item => (
            <Col span={6} style={{ marginTop: '20px' }} key={item.label}>
              <ItemValue {...item} />
            </Col>
          ))}
        </Row>
      </div>
      <div className='grid-charts'>
        <Chart deviceId={chartDeviceId} points={chartPoints} />
      </div>
    </div>
  )
}

export default Grid
